const modalEditPhotoFormCompany = {
  title: 'Edit Company Logo',
  typographyTrue: 'New Company Registration',
  typographyFalse: 'Company Info'
};

export default modalEditPhotoFormCompany;
